import React from 'react';
import { Pressable, View } from 'react-native';

import { Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const LeadChoiceChips = ({
	options,
	selectedValue,
	onSelect,
	disabled = false,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.row}>
			{
				options.map(option => {
					const isActive = option.value === selectedValue;

					return (
						<Pressable
							key={option.label}
							style={({ pressed }) => [
								styles.chip,
								isActive && styles.chipActive,
								disabled && styles.chipDisabled,
								pressed && styles.pressed,
							]}
							onPress={() => onSelect(option.value)}
							disabled={disabled}
							accessibilityRole="button"
							accessibilityLabel={option.label}
							accessibilityState={{ selected: isActive, disabled }}
						>
							<Text style={[styles.label, isActive && styles.labelActive]}>{option.label}</Text>
						</Pressable>
					);
				})
			}
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space, radius, touch } }) => ({
	row: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: space.sm,
		marginBottom: space.sm,
	},
	chip: {
		minHeight: touch.min,
		justifyContent: 'center',
		borderRadius: radius.pill,
		borderWidth: 1,
		borderColor: colors.borderStrong,
		backgroundColor: colors.card,
		paddingHorizontal: space.lg,
	},
	chipActive: {
		backgroundColor: colors.primary,
		borderColor: colors.primary,
	},
	chipDisabled: {
		opacity: 0.6,
	},
	pressed: {
		opacity: 0.8,
	},
	label: {
		...type.bodySmallStrong,
		color: colors.onChip,
	},
	labelActive: {
		color: colors.onPrimary,
	},
});

export default LeadChoiceChips;
